<script>
    import * as Write from '../../script/handle/write'
    import MenuMonster from './menuMonster.svelte'
    import SubViewMonster from './subViewMonster.svelte'
    import ModalMonster from './modal/modalMonster.svelte'

	import { onMount } from 'svelte'
    import { GameBuild } from '../../script/_init'

    export let Monsters

    let ShowMonseterModal = false
    let MonsterPosition = -1, subViewMonster = -1

    let checkTab = []
    Write.CheckInnerData.subscribe(value => {checkTab = value.monster})

	onMount(async () => {
        
    })

    // 몬스터 선택 Modal 호출
    function callMonsterModal() {
        ShowMonseterModal = true
        MonsterPosition = -1
    }
</script>

{#if Monsters.length > 0}
    <MenuMonster bind:Monsters/>
{/if}

<div class='info'>
    <div class="attention">
        <div class="title">※ 참고 및 주의사항</div>
        <ul>
            <li>해당 데이터는 <strong>Build 00{$GameBuild}</strong> 기준 으로 이용이 가능합니다.</li>
            <li>게임 업데이트에 따라 데이터는 변경되며, 그에 따른 게시글 내용도 유동적으로 변경 됩니다.</li>
            <li>특성 데이터는 게임 내 도감 위치에 따라 표시됩니다.</li>
            <li>버그 또는 오타가 있는 경우, 제보 부탁드립니다. => (<a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">제보</a>)</li>
        </ul>
    </div>

    <div class="list">
        {#each Monsters as monster, i}
            <div id='m_{monster.monster}' class="monster" >                
                {subViewMonster = i}
                <SubViewMonster
                    bind:Monster={monster} bind:Position={subViewMonster}
                    bind:CheckTab={checkTab[i]}
                />
            </div>

            <div class="bar"></div>
        {/each}

        {#if Monsters.length < 5}
            <div class="monster add">
                <div class="grid">
                    <div class="title">
                        {Monsters.length + 1} 번
                    </div>

                    <div class="btn">
                        <svg xmlns="http://www.w3.org/2000/svg" class='top' width="25" height="18" viewBox="0 0 25 18" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.2613 4.85226L19.1537 0H-4.88758e-06V4.85226H2.82704e-05V12.3063L4.85229 17.4139L4.85229 4.85226H24.2613Z" fill="#7A67FF"/>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" class='bottom' width="25" height="18" viewBox="0 0 25 18" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.57764e-05 12.5618L5.10769 17.4141H24.2614V12.5618H24.2613V5.10781L19.4091 0.000162125L19.4091 12.5618H4.57764e-05Z" fill="#7A67FF"/>
                        </svg>

                        <button
                            on:click={() => callMonsterModal()}
                        >
                            몬스터 추가
                        </button>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>

<ModalMonster bind:ShowMonseterModal bind:SelectPosition={MonsterPosition}/>

<style lang="scss">
    .info {
        width: 100%;
        height: fit-content;

        .attention {
            background: rgba($color: $cl3, $alpha: 0.3);
            width: calc(100% - 20px);
            height: fit-content;
            padding: 30px 10px;

            .title {
                color: $cl4;
                font-size: 15px;
                font-family: aggro;
            }

            ul, ol {
                margin: 0px;
                padding-left: 25px;
                font-size: 15px;

                li {
                    margin: 5px 0px;
                    word-break: keep-all;
                }

                a {
                    padding: 4px;
                    border-radius: $br1;
                    color: $cl4;
                    font-family: aggro;

                    &:hover {
                        background: $cl5;
                        color: $cl2;
                    }
                }
            }
        }

        .list {
            width: calc(100%);
            height: fit-content;
            margin-top: 30px;

            .monster {
                width: calc(100%);
                height: fit-content;

                &.add {
                    text-align: center;

                    .grid {
                        width: 100%;
                        height: fit-content;
                        display: grid;
                        grid-template-columns: 40px calc(100% - 40px - 30px);
                        grid-column-gap: 30px;
                        
                        .btn {
                            width: calc(100% - 46px);
                            height: fit-content;
                            padding: 3px 4px;
                            position: relative;

                            &:hover {
                                button {
                                    background: $cl3;
                                    cursor: pointer;
                                }
                                svg {
                                    fill: $cl3;
                                    rect { 
                                        fill: $cl3;
                                    }
                                }
                            }

                            svg {
                                position: absolute;

                                &.top {
                                    top: 0;
                                    left: 0;
                                }

                                &.bottom {
                                    bottom: 0;
                                    right: 0 ;
                                }
                            }
                            
                            button {
                                all: unset;
                                background: $cl1;
                                width: calc(100% - 4px);
                                padding: 12px 0 10px 0;
                                border: 2px solid $cl3;
                                color: $cl2;
                                font-size: 20px;
                                font-family: aggro;
                            }
                        }
                    }
                }

                .title {
                    width: fit-content;
                    font-size: 18px;
                    font-family: aggro;
                    text-align: left;
                }
            }

            .bar {
                background: $cl3;
                width: 100%;
                height: 2px;
                margin: 50px 0;
            }
        }
    }
</style>